/**
 * Slice para el manejo del estado del Tracking de Correcciones y Legalizaciones
 */
import { createSlice } from "@reduxjs/toolkit";

const statusShowView = {
  RESULTADOS: true,
  GENERALES: false,
};

const initialState = {
  statusShowView,
};

const trackcrlSlice = createSlice({
  name: "trackcrl",
  initialState,
  reducers: {
    setStatusShowView: (state, action) => {
      state.statusShowView = action.payload;
    },
  },
});

export const { setStatusShowView } = trackcrlSlice.actions;

export default trackcrlSlice.reducer;

export const gatAllState = (state) => {
  return state.trackcrl;
};
